import { useTranslation } from 'react-i18next';

export const BuddingIndexPercentage = ({ bud }: { bud?: number }) => {
  const { t } = useTranslation();
  const budIndex = bud ? bud : 0;
  return (
    <div className="flex">
      <div className="w-60">
        <div className="text-gray-600 text-xl font-bold">
          {t('measurements.details.budding')}
        </div>
        <div className="font-normal">(% of cells budding)</div>
      </div>
      <div className="text-gray-600 text-3xl font-bold">{budIndex.toFixed(2)}</div>
    </div>
  );
};
